import { CheckCircle, Clock, Sparkle, ArrowsClockwise, Warning, ListChecks } from "@phosphor-icons/react";

const CONFIG = {
  pending:         { label: "Pendiente",     bg: "bg-status-warning-bg", fg: "text-status-warning-fg", bd: "border-status-warning-bd", icon: Clock },
  extracting:      { label: "Extrayendo IA", bg: "bg-status-info-bg",    fg: "text-status-info-fg",    bd: "border-status-info-bd",    icon: Sparkle },
  ready_to_review: { label: "Por revisar",   bg: "bg-status-warning-bg", fg: "text-status-warning-fg", bd: "border-status-warning-bd", icon: ListChecks },
  revisado:        { label: "Revisado",      bg: "bg-status-success-bg", fg: "text-status-success-fg", bd: "border-status-success-bd", icon: CheckCircle },
  submitting:      { label: "Subiendo",      bg: "bg-status-info-bg",    fg: "text-status-info-fg",    bd: "border-status-info-bd",    icon: ArrowsClockwise },
  submitted:       { label: "Subido",        bg: "bg-status-success-bg", fg: "text-status-success-fg", bd: "border-status-success-bd", icon: CheckCircle },
  error:           { label: "Error",         bg: "bg-status-error-bg",   fg: "text-status-error-fg",   bd: "border-status-error-bd",   icon: Warning },
};

export default function StatusBadge({ status, size = "sm" }) {
  const c = CONFIG[status] || CONFIG.pending;
  const Icon = c.icon;
  const sizeCls = size === "lg" ? "text-sm px-3 py-1" : "text-[11px] px-2 py-0.5";
  const animate = status === "extracting" || status === "submitting" ? "animate-spin" : "";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border font-medium ${c.bg} ${c.fg} ${c.bd} ${sizeCls}`}
      data-testid={`status-badge-${status}`}
    >
      <Icon className={`w-3 h-3 ${animate}`} weight="bold" />
      {c.label}
    </span>
  );
}
